import { Link } from 'react-router-dom';
import UserAvatarButton from '../components/ora/Global/UserAvatarButton/UserAvatarButton';
import { useInstance } from '../instances/useInstance';
import { MCGRAW_HILL_ROOT } from './mcgrawHill';

/**
 * mcgraw-hill (ORA-1259): the logo above the AI desktop's greeting, a link
 * back to the verticals launcher, as the nav's logo is. Without a logo the
 * greeting keeps the avatar, as everyone else's does.
 */
const McGrawHillGreetingLogo = () => {
  const logoUrl = useInstance().brand.logoUrl;
  if (!logoUrl) return <UserAvatarButton />;

  return (
    <Link
      aria-label="McGraw Hill demos"
      className="block rounded-sm focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
      to={MCGRAW_HILL_ROOT}
    >
      <img alt="" className="block size-14 object-contain" src={logoUrl} />
    </Link>
  );
};

export default McGrawHillGreetingLogo;
